import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, TableCell, Modal ,Button} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import InfantIndicator from "../InfantIndicator";
import { ActionsMenu } from '../ActionsMenu'
import { isFlightOpen } from "../../util/isFlightOpen";
import { FlightTimeDisplay } from "../../util/FlightTimeDisplay";
import { StyledTableRow } from '../../util/StyledTableRow'
import { PaxInfoResult } from '../PaxInfoResult';
import SummaryModal from '../../modals/Summary';
import _ from 'lodash'

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  tableCellLessPad: {
    padding: '10px'
  },
  mobileRowItem: {
    marginTop: '5px',
    marginBottom: '0px'
  }
});

export const MobileResult = (props) => {
  let hasStandbyPax = props.row.PaxList.match(/\- (SA|MM|PN)/g);
  const {row, paxMove, modalClasses, newTexts, date} = props;
  let betterRow = typeof row === 'object' ? _.cloneDeep(row) : {}
  betterRow.status = isFlightOpen(betterRow)
  const [openAccordion, setOpenAccordion] = React.useState(row.passengers && row.passengers.length);
  const [openSummary, setopenSummary] = useState(false);
  const rowItemClasses = useRowStyles();

  const handleOpenSummary = () => {
    setopenSummary(true);
  };
  const handleCloseSummary = () => {
    setopenSummary(false);
  };
  const standbyStyle = {
    color: 'red',
    fontWeight: 'bold',
  };
  
  return (
    <React.Fragment>
      <StyledTableRow className={rowItemClasses.root}>
        <TableCell className={rowItemClasses.tableCellLessPad} >
          <h4 className={rowItemClasses.mobileRowItem}>{row.FlightNumber}</h4>
          <p className={rowItemClasses.mobileRowItem}>{row.TailNumber}</p>
        </TableCell>
        <TableCell className={rowItemClasses.tableCellLessPad}>
        <Button variant="contained" size="small" onClick={handleOpenSummary}>SUMMARY</Button>
        <Modal 
            open={openSummary} 
            onClose={handleCloseSummary} 
            aria-labelledby="simple-modal-title" 
            aria-describedby="simple-modal-description"
          >
             <SummaryModal pax={row} closeModal={handleCloseSummary} modalClasses={modalClasses} />
          </Modal>
      </TableCell>
        <TableCell className={rowItemClasses.tableCellLessPad}>
          <p className={rowItemClasses.mobileRowItem}>{row.Origin} <FlightTimeDisplay type='dep' row={row} /></p>
          <p className={rowItemClasses.mobileRowItem}>{row.Destination} <FlightTimeDisplay type='arr' row={row} /></p>
        </TableCell>
        <TableCell className={rowItemClasses.tableCellLessPad}>
          <ActionsMenu row={betterRow} date={date} paxMove={paxMove} modalClasses={modalClasses} isMobile={true} />
        </TableCell>
        <TableCell className={rowItemClasses.tableCellLessPad}>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpenAccordion(!openAccordion)}>
            {openAccordion ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
         <span>{row.Load}</span>{' '}{hasStandbyPax ? <span style={standbyStyle}>STBY</span> : ''}{' '}{hasStandbyPax ? `(${hasStandbyPax.length})` : ''}
          <div></div>
          <InfantIndicator paxArr={row.passengers} isMobile={true} />
        </TableCell>
      </StyledTableRow>
      <PaxInfoResult row={row} modalClasses={modalClasses} isMobile={true} openAccordion={openAccordion} newTexts={newTexts} />
    </React.Fragment>
  )
}